import { Box, Button, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import TableHeader from '../../common/TableHeader'
import { useParams, useSearchParams } from 'react-router-dom'
import api from '../../../service/api'
import { formatDate, Icons } from '../../../utils/utilities'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import noQBanksImg from '../../../assets/no-questions.svg'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import AuditQuestionBankViewer from '../questionbanks/AuditQuestionBankViewer'
import CustomTable from '../../common/custom-table/CustomTable'

const columns = [
    { field: "index", index: true, name: "Sl. no.", align: "center", rowPadding: "10px 20px" },
    { field: "name", name: "Question Bank", cellStyles: { textTransform: "capitalize" } },
    { field: "created_at", name: "Created on", renderCell: item => formatDate( item.created_at ), },
    { field: "subject", name: "Subject", renderCell: item => item?.subject?.subject_name || "Not Available" },
    { field: "questions", name: "Questions", align: "center", },
]

const QuestionBankDetails = ( { userData } ) => {

    const [loading, setLoading] = useState( true )
    const [error, setError] = useState( null )
    const [questionBanks, setQuestionBanks] = useState( [] )
    const [selectedQuestionBank, setSelectedQuestionBank] = useState( null )

    const { empcode } = useParams()
    const [searchParams] = useSearchParams( { legacy: true } )
    const legacy = searchParams.get( 'legacy' ) === 'true'

    const { palette, layout } = useTheme()

    const handleDialogClose = () => {
        setSelectedQuestionBank( null )
    }

    const loadQuestionBanks = useCallback( async () => {
        setLoading( true )
        try {
            const { data: { data } } = await api.audit.getQuestionBanksByFacultyId( empcode, { legacy } )
            setQuestionBanks( data )
            setError( false )
        } catch ( err ) {
            setError( err?.response?.data?.message || "Something went wrong while fetching assignments details." )
        } finally {
            setLoading( false )
        }
    }, [empcode, legacy] )

    useEffect( () => {
        loadQuestionBanks()
    }, [loadQuestionBanks] )

    return (
        <Box maxHeight="350px" display="flex" flexDirection="column" overflow="hidden">

            {selectedQuestionBank && <AuditQuestionBankViewer questionbank={selectedQuestionBank} handleClose={handleDialogClose} openState={Boolean( selectedQuestionBank )} />}

            {/* Data */}
            {!loading && !error && questionBanks.length > 0 && <CustomTable onRowClick={( item ) => setSelectedQuestionBank( item )} columns={columns} data={questionBanks} />}

            {/* Loading */}
            {loading && !error && <Box padding="50px 20px" display="flex" justifyContent="center">
                <DataLoadingSpinner waitingMessage="Please wait! Loading question banks..." />
            </Box>}

            {/* Error */}
            {error && <TryAgainMessageBlock getData={loadQuestionBanks} loading={loading} err={error} />}

            {/* No Data */}
            {!loading && !error && questionBanks.length === 0 && <Box borderRadius={layout.borderRadius} bgcolor={palette.contentBg} padding="20px" gap="20px" display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                <img src={noQBanksImg} height="100px" alt="Something went wrong!" />
                <Typography variant="subtitle2"><em>{userData.employee_name}</em> hasn't created any question banks!</Typography>
                <Button variant='outlined' startIcon={Icons.default.Replay} color='secondary' onClick={loadQuestionBanks}>fetch again</Button>
            </Box>}
        </Box>
    )
}

export default QuestionBankDetails
